import { jsx as _jsx } from "react/jsx-runtime";
import { VisuallyHidden } from "../../VisuallyHidden";
import * as S from "../SharedForm.styled";
export var FieldTemplate = function (props) {
    var children = props.children, hidden = props.hidden;
    if (hidden) {
        return _jsx(VisuallyHidden, { children: children });
    }
    return _jsx(S.Field, { children: children });
};
